module.exports = __webpack_public_path__ + "media/src/img/youtube-icon-bf7c6ce58f255577a44674dceffd9a86.svg";